<template>
  <v-dialog v-model="open" width="600" persistent :fullscreen="!$mq.isDesktop()">
    <v-card class="" v-if="order && user">

      <div
        class="flex pa-5 flex-vcenter"
      >
        <h3 class='ma-0' style='margin: 0'>
          
        </h3>
        <span class="flex-grow-1" />
        <v-btn @click="open=false" icon><i class="fas fa-close" style='font-size: 32px'/> </v-btn>
      </div>

      <div>
        <div class="pt-0 pa-5" v-if="!loading">
          <h3 class="text-center pa-5 text-title-big" style='color:var(--quomi-red)'> 
            Avviso di modifica del carrello
          </h3>
          <p v-if="recipeToRemove.length > 0">
            Le seguenti ricette non sono disponibili per la nuova data di consegna.
          </p>

          <div v-for="recipe in recipeToRemove" class="recipe-item ma-2">
            <div class="recipe-image"><img :src="recipe.images.small"></div>
            <div class="recipe-name pa-3"><span>{{ recipe.name }}</span></div>
          </div>

          <p v-if="productsToAdjust.length > 0">
            I seguenti prodotti non sono disponibili nella quantità richiesta per la nuova data di consegna, di seguito la nuova quantità disponibile.
          </p>

          <div v-for="product in productsToAdjust" class="recipe-item ma-2">
            <div class="recipe-image"><img :src="product.product.images.small"></div>
            <div class="recipe-name pa-3"><span>{{ product.product.name }}</span></div>
            <div class="recipe-name pa-3"><span>{{ product.qty.new == "0" ? "Non disponibile" : product.qty.new }}</span></div>
          </div>
          <p>
            Cliccando su "Torna alla tua spesa", questi prodotti verranno rimossi e/o modificate le loro quantità nel tuo carrello e sarai reindirizzato alla pagina di acquisto per continuare la tua spesa. 
          </p>
          <p v-if="minPriceReached">In alternativa clicca su "Conferma ordine" per procedere con l'acquisto dei prodotti disponibili.</p>
          <div class="ctas flex align-items-center">
            <CTA
              content="Torna alla tua spesa"
              :loading="innerLoading"
              :disabled="innerLoading"
              isArrowLeft
              @click="remove('flow-subscribed')"
              class="ma-auto my-4"
            />

            <span v-if="minPriceReached">oppure</span>

            <CTA
              v-if="minPriceReached"
              content="Conferma ordine"
              :loading="innerLoading"
              :disabled="innerLoading"
              isArrow
              @click="remove('thank-you-recurring')"
              class="ma-auto my-4"
            />
          </div>

          <div class="text-center">
            <a href="#" @click="open = false" class="link-detail">(annulla modifica)</a>
          </div>
        </div>
        <div v-else>
          <loading-spin
              :height='200'
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>

import { deliverySelect } from '../../mixins/delivery'
import { WeekPlanApi } from '../../api/WeekPlanApi'
import { orderAction } from '../../mixins/orderAction'
import { StockApi } from '../../api/StockApi'
import { OrderApi } from '../../api/OrderApi'
import { orderStore } from '../../store/orderStore'
import { plansStore } from '../../store/plansStore' 
const moment = require('moment')

export default {
  data() {
    return {
      open: false,
      loading: false,
      innerLoading: false,
      recipeToRemove: [],
      productsToAdjust: [],
      orderStore: orderStore.state,
      plansStore: plansStore.state,
      recipes_id: {},
      availableExtras: [],
      minPriceReached: null
    }
  },
  mixins: [
    orderAction,
    deliverySelect
  ],
  computed: {
    user() {
      return this.$root.user;
    },
    order() {
      return this.user ? this.user.order : null
    }
  },
  methods: {
    getShipmentDay() {
      let d = this.$_deliverySelect_selectedDay ? this.$_deliverySelect_selectedDay.shipment_day : null

      return d
    },
    loadMenuById(id) {
      let api = new WeekPlanApi()
      return api.current({shipment_day: this.getShipmentDay(), id:id}).then(i => {
        return i.body.data.resource;
      })
    },
    confirm(status) {
      this.open = false;
      this.$emit('confirm');
      this.loading = false;
      return this.callback(status);
    },
    calculate () {
      if (!this.order) {
        return this.confirm(true);
      }
      return this.calculateDiff(this.order.week_plan.id, this.$_deliverySelect_selectedDay ? this.$_deliverySelect_selectedDay.week_plan_id : null);
    },
    remove (urlback) {
      if (this.innerLoading) {
        return;
      }

      this.innerLoading = true;

      this.recipeToRemove.map(recipe => {
        this.$_orderAction_unsetOrderRecipe(recipe)
      })

      this.productsToAdjust.map(product => {
        if (product.type == 'recipe') {
          this.$_orderAction_setOrderRecipe(product.product, product.qty.new)
        } else {
          this.$_orderAction_changeExtra(product.product, product.qty.new)
        }
      })

      this.$_orderAction_updateCurrentRecipes().then(i => {
        this.innerLoading = false;
      }).then(i => {
        return this.confirm(false);
      }).then(i => {
        this.$router.push({name: urlback})
      })
    },
    calculateDiff (orderId, zoneId) {

      this.recipeToRemove=[];
      this.productsToAdjust=[];

      /* this.open = true; */

      // Check different menu
      let date = this.order.date.shipment, p;
      if (!zoneId) {

        p = Promise.resolve(1)
      } else {
        p = this.loadMenuById(zoneId).then(zoneMenu => {


          date = moment(zoneMenu.date.start).add(this.getShipmentDay() - 1, 'days').format("YYYY-MM-DD"); 
          this.order.recipes.map(recipeOrder => {

            let recipeMenu = zoneMenu.recipes.find(recipeMenu => {
              return recipeMenu.id == recipeOrder.id;
            })

            if (!recipeMenu) {
              /*this.recipeToRemove.push({
                product: recipeOrder,
                qty: -1
              });*/
              this.recipeToRemove.push(recipeOrder)
            }
          })

        })
      }

      p.then(i => {

        let api = new StockApi()

        // let date = new Date()
        let people = 2 
        let ids = this.order.recipes.filter(i => this.recipeToRemove.find(r => r.id == i.id) == null).map(i => i.product.id).concat(this.order.extras.map(i => i.id))
        return api.index({date: date, people: people, ids: ids.join(",")})
      }).then(response => {

        let r = this.order.recipes.map(i => {
          i.type = 'recipe'
          return i
        })
        r.concat(this.order.extras).map(i => {
          let id = i.type == 'recipe' ? i.product.id : i.id
          if (i.quantity > response.body[id]) {
            this.productsToAdjust.push({
              qty: {
                new: response.body[id],
                old: i.quantity,
              },
              type: i.type == 'recipe' ? 'recipe' : 'extra',
              product: i
            })
          }
        })
      }).then(i  => {
        if (this.recipeToRemove.length === 0 && this.productsToAdjust.length === 0) {
          this.confirm(true);
        } else {
          this.updateOrder()
          this.open = true
          this.loading = false;
        }
      })
    },

    getRecipeParams() {
      let checkRecipes = this.order.recipes.filter(el => !this.recipeToRemove.includes(el))
      return checkRecipes.map(el => {
        this.recipes_id[el.id] = { id: el.id, quantity: el.quantity }
      })
      
    },
    
    getExtrasParams() {
      let checkExtras = this.order.extras.filter(el => !this.productsToAdjust.includes(el)) 
      checkExtras.map(el => {
          this.availableExtras.push({ id: el.id, quantity: el.quantity })
          return this.availableExtras
      })

    },

    updateOrder () {
      var recipes_id = this.getRecipeParams()
      var extra = this.getExtrasParams()

      plansStore.loadPlans().then(i => {
				return plansStore.findPlan({
					people: this.order.plan.people,
					meals: Object.values(recipes_id).map(a => a.quantity).reduce((a, b) => a + b, 0)
				})
			}).then(plan => {
        var plan_id = plan.id
        var token = this.order ? this.order.token : null
        var params = { __preserve: 1, recipes_id, extra, plan_id }

        var api = new OrderApi()
        return api.update(token, params)
      }).then(response => {
        this.minPriceReached = response.body.data.resource.prices.min_reached
      })
    }
  },

  created () {

    this.listener = (e) => {
      this.loading = true;
      this.callback = e.detail;
      this.calculate();
    }

    window.addEventListener('checkout-change-menu', this.listener);
  },
  destroyed() {
    window.removeEventListener('checkout-change-menu', this.listener);
  }
}
</script>
<style scoped>
  .recipe-item {
    display: flex;
    align-items: center;
    max-height: 80px;
    opacity: 0.7;
  }
  .recipe-image {
    min-width: 50px;
    min-height: 33px;
    max-width: 50px;
    max-height: 33px;
    overflow: hidden;
    vertical-align: middle;
    margin-right: 10px;
    border-radius: 4px;
  }
  .recipe-image img {
    max-width: 100%;
  }
  .recipe-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    position: relative;
    line-height: 1.1;
  }

  .recipe-name span {
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  @media (max-width: 648px) {
    .ctas {
      flex-direction: column;
      justify-content: center;
    }
  }
</style>